<template>
  <div style="height: 100%;">
    <div class="customer-header">
      <div style="display: flex; align-items: center;width: 100%;">
        <mm-icon
          v-if="isIO"
          name="chevronleft"
          class="icon-chevronleft"
          style="cursor: pointer;"
          @click="cancelOrder"
        />
        <div style="margin-left: 12px;">
          <div
            class="title"
            style="font-size: 20px;font-weight: bold;"
          >
            {{ orderStatusStr }}
          </div>
          <div>{{ countDownTime }}后订单失效</div>
        </div>
        <ContactService style="margin-left: auto;" />
      </div>
    </div>
    <div class="content">
      <div class="content-infos">
        <div class="title">
          订单信息
        </div>
        <div class="order-info-wrap">
          <div
            v-for="item in orderInfoJson"
            :key="item.label"
            class="order-info"
          >
            <div class="label">
              {{ item.label }}
            </div>
            <div class="value">
              {{ item.value || '-' }}
            </div>
          </div>
        </div>
      </div>
      <div
        v-show="!isMobile"
        style="margin-top: 32px;"
      >
        <div class="title">
          支付方式
        </div>
        <div class="pay-wrap">
          <canvas
            style="left: 99999px;top: 9999999px;position: absolute;"
            name="qrCode"
            width="118"
            height="118"
          />
          <img
            class="qrcode"
            :src="qrCodeLink"
          >
          <div class="pay-info">
            <div>请使用「支付宝」扫码付款</div>
            <div>原价 <span>¥{{ order.original_amount }}</span></div>
            <div>优惠 <span style="color: #F4A127;font-weight: bold;">-¥{{ Number(order.original_amount) - Number(order.amount) }}</span></div>
            <div style="line-height: 28px;display: flex;align-items: center;">
              <div style="line-height: 28px;margin-right: 2px;">
                应付
              </div>
              <span style="color: #0891ff;font-size: 20px;font-weight: bold;">¥{{ order.amount }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-show="isMobile">
        <mm-button
          type="primary"
          class="submit-btn"
          @click="handlePay"
        >
          <div
            class="discount"
            v-if="order.amount !== order.original_amount"
          >
            优惠 ¥{{ order.original_amount - order.amount }}
          </div>
          立即支付
          <span
            v-if="order.amount"
            style="font-weight: bold;margin: 0 4px;"
          >¥{{ order.amount }} </span>
          <span
            v-if="order.amount !== order.original_amount"
            style="text-decoration: line-through;"
          >¥{{ order.original_amount }}</span>
        </mm-button>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode'
import Servers from "@config";
import PaymentApi from "@api/payment";
import ContactService from './ContactService.vue';

const renderOrderInfoJson = (accountInfo, order, productType, productInfo) => {
  let service_info = [];
  if (productType === 'leads_personal') {
    service_info = productInfo.order.service_info;
  } else {
    service_info =  order.service_info ? JSON.parse(order.service_info) : []
  }

  const service_count = service_info.length ? Number(service_info[0].extra_count) + Number(service_info[0].standard_count) : 0;

  let orderDetail = {
    label: '购买次数',
    value: service_count + '次'
  }

  if (productType === 'leads_personal') {
    const version_name = productInfo.order.version_name;
    const productStr = service_info.map((item) => item.standard_count + item.unit_desc + item.service_name).join('、');
    orderDetail = {
      label:'购买内容',
      value: `${version_name} ( ${productStr} )`
    }
  }

  return [{
        label: '下单账号',
        value: accountInfo.account_id
    }, orderDetail , {
        label: '到期时间',
        value: order.valid_to,
    }, {
        label: '下单时间',
        value: order.create_time
    },{
        label: '订单编号',
        value: order.order_no
    }]}
const str_map = {
  '1': '待买家付款'
}

const getPayUrl = (order) => {
  const host = Servers.oss.includes('https:') ? Servers.oss : `https:${Servers.oss}`;
  const { order_no, amount } = order;
  return `${host}/internal-api/customer/ali-pay-customer?order_no=${order_no}&amount=${amount}`
}
export default {
    name: "OrderInfo",
    props: {
        order: {
            type: Object,
            default: () => {}
        },
        accountInfo: {
            type: Object,
            default: () => {}
        },
        productType: {
            type: String,
            default: ''
        },
        productInfo: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            timer: null,
            countDownTime: '',
            isMobile: false,
            pollTimer: null,
            qrCodeLink:null,
        };
    },
    components: {
      ContactService
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            // 判断当前设备是否是移动端
            this.isMobile = /Android|Mobi|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
            this.countDown();
            const $canvas = document.querySelector('canvas[name="qrCode"]');
            this.$canvas = $canvas;
            this.startPolling();
        },
        countDown() {
            let {end_time} = this.order;
            const now = new Date().getTime();
            end_time = end_time ? end_time.replace(' ', 'T') : '';
            const endTime = new Date(end_time).getTime();
            const leftTime = endTime - now;
            const leftSecond = parseInt(leftTime / 1000);
            const day = Math.floor(leftSecond / (60 * 60 * 24));
            const hour = Math.floor((leftSecond - day * 24 * 60 * 60) / 3600);
            const minute = Math.floor((leftSecond - day * 24 * 60 * 60 - hour * 3600) / 60);
            const second = Math.floor(leftSecond - day * 24 * 60 * 60 - hour * 3600 - minute * 60);
            this.timer = setTimeout(() => {
                this.countDown();
            }, 1000);
            this.countDownTime = `${minute} 分 ${second} 秒`;
            // 剩余时间小于1s
            if (leftTime < 0) {
                clearTimeout(this.timer);
                this.$message.warning('订单已失效');
                // 刷新当前页面
                window.location.reload();
            }

        },
        handlePay() {
          window.location.href = this.payUrl;
        },
        cancelOrder() {
          PaymentApi.changeOrderStatus({
              order_no: this.order.order_no,
              token: this.accountInfo.token,
              status: 2
          }).then(() => {
              // 刷新当前页面
              window.location.reload();
          }).catch((res)=>{
              if (res.code === -1 && res.msg ) {
                window.location.href = '/payment/fail?msg=' + res.msg;
              }
            })
        },
        getOrderStatus() {
            if (!this.order.order_no) {
              return;
            }
            PaymentApi.getOrderStatus({order_no: this.order.order_no}).then(res => {
              const status = Number(res.status);
              if (status === 1) {
                window.location.href = '/payment/success?productType=' + this.productType;
              } else if (status === 2 || status === -1 ) {
                this.$emit('cancelOrder');
              }
            });
        },
        startPolling() {
            this.pollTimer = setInterval(() => {
                this.getOrderStatus();
            }, 1000);
        },
    },
    beforeDestroy() {
        clearInterval(this.timer);
        clearInterval(this.pollTimer);
    },
    computed: {
        orderInfoJson() {
            return this.productInfo.order ? renderOrderInfoJson(this.accountInfo, this.order,this.productType, this.productInfo) : [];
        },
        orderStatusStr() {
          const status = this.accountInfo.is_paid_order;
          return str_map[status]
        },
        payUrl() {
          return this.order.order_no ? getPayUrl(this.order) : '';
        },
        isIO() {
          return this.productType === 'io';
        }
    },
    watch: {
        order: {
            handler() {
              this.$nextTick(() => {
                QRCode.toCanvas(this.$canvas, this.payUrl, {
                  width: 118, height: 118, margin: 0
                })

                // 保存Canvas的图像数据
                var canvasImage = this.$canvas.toDataURL();
                this.qrCodeLink = canvasImage;
            })
            },
            deep: true
        },
    }
}
</script>

<style lang="scss" >
@font-face {
  font-family: NumberFont;
  src: url('../../../assets/font/MiSans-Medium.ttf');
}

.content {
.title {
    font-size: 14px;
    font-style: normal;
    font-weight: 600;

    &::before {
        content: '';
        display: inline-block;
        width: 4px;
        height: 14px;
        background: #0891FF;
        margin-right: 2px;
        margin-bottom: -2px;
    }
}
}

.customer-header {
  color: #fff;
}
.order-info-wrap {
    display: flex;
    flex-wrap: wrap;
    gap: 16px 40px;
    padding: 16px 0 0;
    .order-info {
        display: flex;
        align-items: flex-start;
        width: calc(50% - 20px);
        .label {
            flex-shrink: 0;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            color: #999999;
            width: 88px;
        }
        .value {
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            color: #333333;
        }

    }

    @media screen and (max-width: 600px) {
        .order-info {
            width: 100%;
        }
    }
}

.pay-wrap{
    display: flex;
    width: 100%;
    padding: 16px;
    flex-direction: row;
    align-items: flex-start;
    gap: 16px;
    border-radius: 8px;
    background: var(--primary-1, #F0F8FF);
    margin-top: 16px;
    .qr-code {
        width: 118px;
        height: 118px;
    }
    .pay-info {
        color: var(--medium-8, #666);
        font-family: PingFang SC;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        gap: 8px;
        display: flex;
        flex-direction: column;

        span {
          font-family: NumberFont;
        }
    }
}

.qrcode{
  width: 118px;
  height: 118px;
}
</style>
